import React, { FC, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import HeroSearch from './sections/hero/HeroSearch'
import FreshListings from './sections/fresh/FreshListings'
import RecommendedListings from './sections/recommended/RecommendedListings'
import AllListings from './sections/all/AllListings'
import HowItWorks, { HOW_IT_WORKS_ID } from './sections/how/HowItWorks'
import MainBanner from './sections/banner/MainBanner'
import NewsSection from './sections/news/NewsSection'
import { HeadPage } from 'src/components/elements'
import { useTranslation } from 'react-i18next'
import RequestsInbox from './sections/requests-inbox/RequestsInbox'
import MyPropertiesProfile from 'src/components/pages/profile/sections/my-properties/MyPropertiesProfile'

interface IHome {}

const Home: FC<IHome> = () => {
  const { t } = useTranslation()
  const { hash } = useLocation()

  // The footer links to "how it works" on this page
  useEffect(() => {
    if (hash === `#${HOW_IT_WORKS_ID}`) {
      document.getElementById(HOW_IT_WORKS_ID)?.scrollIntoView({ behavior: 'smooth' })
    }
  }, [hash])

  return (
    <>
      <HeadPage className="hidden md:flex" title={t('cabinet')} />
      <HeroSearch />
      <MainBanner />
      <RecommendedListings />
      <FreshListings />
      {/* Unified requests inbox (D2/D3): Вихідні|Вхідні in one place, replacing
          the two separate sections that each showed their own "Усі" tab. */}
      <RequestsInbox />
      <MyPropertiesProfile />
      {/* More listings at the bottom of the home page (owner feedback) */}
      <AllListings />
      <HowItWorks />
      <NewsSection />
    </>
  )
}

export default Home
